import { Injectable } from '@angular/core';
import { BBService } from 'bookingbug-core-js';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { FormGroup } from '@angular/forms';
@Injectable({
	providedIn: 'root',
})
export class DatastoreService {

	constructor(
		private router: Router
	) {
		this.isCitizenship$ = this.citizenship.asObservable();

	}

	// new function called agentRestart
	agentRestart() {
		// clear all localstorage
		localStorage.clear();

		//clear all session storage
		sessionStorage.clear();

		//clear variables
		this.startQuestions = null;
		this.type_of_appointment = null;
		this.appointment_type = null;
		this.totalCost = null;
		this.pageContent = null;
		this.reference = null;
		this.isCitizenshipRoute = null;
		this.dateCapInitDate = null; // used to cap calendar dates one year from entered date

		// client details
		this.booker_first_name = null;
		this.booker_last_name = null;
		this.booker_email = null;
		this.booker_phone = null;
		this.lookupResponses = [];
		this.costBreakDown = null;
		this.selectedAddress = null;
		this.setService = null;
		this.setResource = null;
		this.extraDuration = 0; // obtained from questions
		this.childDob = false;
		this.bookingQuestions = [];
		this.unselectedLocations = [];
		this.bookingForm = null;
		this.companyAnswers = null;
		this.selectedDate = null;
		this.selectedSlot = null;
		this.selectedResource = null;
		this.selectedService = null; //used only to store the service incase we switch to the alt one
		this.selectedDepartment = null; //used only to store the service incase we switch to the alt one
		this.locations = [];
		this.bookingAnswers = null;

		if (this.isCitizenshipRoute) {
			this.router.navigate(['/start/citizenship']);
			return;
		} else {
			this.router.navigate(['/agent']);
			return;
		}
	}

	startQuestions: any;
	type_of_appointment: any;
	appointment_type: any;
	public totalCost: any;
	public pageContent: any;

	public firstSlotAnalytic: any;
	public firstSlotAnalyticKey: string;

	public reference: any;
	public isCitizenshipRoute: any;
	public dateCapInitDate: any; // used to cap calendar dates one year from entered date

	public serviceQuestionSchema: Record<string, any>;
	public selectedSchema: string;
	companyQuestionsForm: FormGroup = new FormGroup({});

	// client details
	public booker_first_name: any;
	public booker_last_name: any;
	public booker_email: any;
	public booker_phone: any;
	public lookupResponses: any[] = [];
	public costBreakDown: any;
	public selectedAddress: any;

	public setService: any;
	public setResource: any;
	public staff_set: any;
	public autoSelectedStaff: any;

	public extraDuration = 0; // obtained from questions

	public childDob: any = false;

	public bookingQuestions = [];

	public unselectedLocations = [];

	public _extraItems = [];

	public bookingForm;
	public companyAnswers;

	public selectedDate;

	public selectedSlot;

	public selectedResource;

	public selectedService; //used only to store the service incase we switch to the alt one
	public selectedDepartment; //used only to store the service incase we switch to the alt one

	public locations = [];

	public bookingAnswers;

	public customerDetailsForm;

	public client;

	public clientCreated = false;

	public address;

	public latitude;

	public longitude;

	public endSlot;

	public customerQuestions;

	public companyQuestions;

	public address1;

	public selectedLocation;

	public booking;

	public totalPrice;

	public adminJourney = false;

	public adminAuthToken = '';

	public purchase: any;

	public serviceBookingType: any;

	public selectedSuggestion: any;

	public config: any;

	public serviceFees: any;

	public ceremonyDate: any;

	public deathDate: any;

	public mccdRegDate: any;

	public journeyRoute: string;

	public skipLocationsPage = false;

	public postageCounts: any;

	public citizenshipFees = {
		'mon_fri_9_5': {
			'individual': "e82005a6-ccc7-456c-bd54-8db1fe1ed53c",
			'family': "c8404c9a-baa0-4827-ad7c-cc23c820a4f2",
		},
		'mon_fri_after_5': {
			'individual': "f2c8a041-4669-4018-a7a4-acfe73cc5226",
			'family': "a37d9763-ccc3-43d6-a610-edc0c401fb36"
		},
		'sat': {
			'individual': "df21b5b2-574e-4bbc-988c-92d58f3d15d4",
			'family': "74fcf05b-d00c-42ce-baae-0a14c3c555d9"
		},
		'sun': {
			'individual': "c548c266-950b-4a00-b8e6-e71fd6fc7827",
			'family': "c1cac859-db1d-4de1-a8bd-3ebfc7d5ebc3"
		}
	};
	public citizenshipGroupFees = {
		'mon_fri_9_5': {
			'individual': "cdbf9280-924e-4650-b8ea-d6108ca06c07",
			'family': "e26ce754-13b8-4265-8c79-91b395aceb71",
		},
		'mon_fri_after_5': {
			'individual': "521a2c7b-db12-4b87-a8cc-f1e413d29b71",
			'family': "4534d80f-b3b0-47e1-9935-f968c6d2d749"
		},
		'sat': {
			'individual': "d01d36f4-855a-4708-baca-d94f78436359",
			'family': "a87b1d76-0e8a-4313-8279-0762a9a08395"
		},
		'sun': {
			'individual': "1b0c19c6-d4c4-4857-bbd0-50b01beb5c2d",
			'family': "bb4e587c-ec0e-479b-97df-a293e14b7284"
		}
	};
	public citizenshipKey = '';

	public familyCitizenshipBooking = false;

	public groupCitizenshipBooking = false;

	public citizenshipExtraItem;

	notify: Subject<boolean> = new Subject<boolean>();
	onNotify(event) {
		this.notify.next(true);
	}

	private addFeesSubject = new BehaviorSubject<any>(null);
	addFees$ = this.addFeesSubject.asObservable();
	triggerAddFees(fees: any) {
		this.addFeesSubject.next(fees);
	}

	public citizenship: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public isCitizenship$: Observable<boolean>;
	updateCitizenship(val: boolean) {
		this.citizenship.next(val);
	}

	public certificateStore: any;

	public applicationStore:
		| {
			formData: Record<string, string> | undefined;
			applicationType: string;
			formId: string;
			applicationNumber: string | undefined;
		}
		| undefined;
}
